import { section } from '@/glow';
import { on } from '@/glow/events';
import Carousel from '@/lib/carousel';

section('social-proof', {
  carousel: null,
  events: [],
  onLoad() {
    const carouselWraps = this.container.dataset.carouselWraps === 'true';

    this.carousel = Carousel(this.container, 'social-proof', {
      wrapAround: carouselWraps,
      adaptiveHeight: false,
    });
  },

  onUnload() {
    this.caorusel && this.carousel.destroy();
    this.events.forEach(unsubscribe => unsubscribe());
  },

  onBlockSelect({ target: item }) {
    if (this.carousel) {
      this.carousel.select(item.dataset.index);
    } else {
      this.events.push(
        on('social-proof:initialized', () => {
          this.carousel.select(item.dataset.index);
        })
      );
    }
  },
});
